'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var Vue = _interopDefault(require('vue'));
var vuePropertyDecorator = require('vue-property-decorator');
var config = require('../../config/config.js');

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
exports.default = class extends Vue {
  constructor() {
    super(...arguments);
    this.error = false;
  }
  created() {
    this.click = this.click.bind(this);
  }
  render(h) {
    return h(this.tag, {
      attrs: __spreadProps(__spreadValues({}, this.$attrs), {
        "href": this.href,
        "is-active": this.isActive
      }),
      on: {
        click: this.click
      }
    }, [this.$slots.default]);
  }
  get isActive() {
    return this.route.isActive ? this.route.isActive() : false;
  }
  get route() {
    const { language } = config.magicConfig;
    if (typeof this.to === "number" || typeof this.to === "string") {
      return config.magicConfig.getRoute({
        route: Number(this.to),
        params: {
          language
        }
      });
    }
    return config.magicConfig.getRoute(__spreadProps(__spreadValues({}, this.to), {
      params: __spreadProps(__spreadValues({}, this.to.params), {
        language
      })
    }));
  }
  get href() {
    if (this.route.hasOwnProperty("href")) {
      return this.route.href;
    } else {
      return "javascript:void(0)";
    }
  }
  click(e) {
    if (!this.route.href) {
      e.preventDefault();
      this.route.go();
    }
  }
};
__decorateClass([
  vuePropertyDecorator.Prop({
    validator(value) {
      return typeof value === "number" || typeof value === "string" || typeof value === "object";
    }
  })
], exports.default.prototype, "to", 2);
__decorateClass([
  vuePropertyDecorator.Prop({
    type: String,
    default: "a"
  })
], exports.default.prototype, "tag", 2);
__decorateClass([
  vuePropertyDecorator.Emit("click")
], exports.default.prototype, "click", 1);
exports.default = __decorateClass([
  vuePropertyDecorator.Component
], exports.default);
